/* Predictive search under the header input and the search page box: products first, guides after. */
import { $$, debounce, money, fmt } from '@theme/utils';

const T = () => window.Theme;
const img = (u, w) => u ? esc(u + (u.includes('?') ? '&' : '?') + 'width=' + w) : '';
const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

function initPredictive(root) {
$$('form[data-predictive]', root).forEach((form) => {
  const input = form.querySelector('input[name="q"]'), box = form.querySelector('.pres');
  if (!input || !box || form.__predictive) return;
  form.__predictive = true;
  let ctrl = null, lastQ = '';
  const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); };
  const render = (q, data) => {
    const r = data.resources && data.resources.results ? data.resources.results : {};
    const products = r.products || [], articles = r.articles || [], pages = r.pages || [];
    if (!products.length && !articles.length && !pages.length) { box.innerHTML = `<p class="small q">${esc(T().strings.noResults)} <b>${esc(q)}</b></p><a class="all link" href="${T().routes.search}?q=${encodeURIComponent(q)}">${esc(fmt(T().strings.seeAll, { q }))}</a>`; box.hidden = false; input.setAttribute('aria-expanded', 'true'); return; }
    let html = '';
    if (products.length) {
      html += `<span class="lab">${esc(T().strings.products)}</span>` + products.map((p) => `<a class="row" href="${esc(p.url)}"><span class="ph flat has-img">${p.featured_image && p.featured_image.url ? `<img src="${img(p.featured_image.url, 96)}" alt="" width="48" height="48" loading="lazy">` : ''}</span><span><b>${esc(p.title)}</b></span><small>${money(Math.round(parseFloat(p.price) * 100))}</small></a>`).join('');
    }
    if (articles.length) html += `<span class="lab">${esc(T().strings.guides)}</span>` + articles.map((a) => `<a class="row" href="${esc(a.url)}"><span class="ph flat has-img">${a.image ? `<img src="${img(a.image, 96)}" alt="" width="48" height="48" loading="lazy">` : ''}</span><span><b>${esc(a.title)}</b></span><small></small></a>`).join('');
    if (pages.length) html += `<span class="lab">${esc(T().strings.pages)}</span>` + pages.map((p) => `<a class="row" href="${esc(p.url)}"><span></span><span><b>${esc(p.title)}</b></span><small></small></a>`).join('');
    html += `<a class="all link" href="${T().routes.search}?q=${encodeURIComponent(q)}">${esc(fmt(T().strings.seeAll, { q }))}</a>`;
    box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true');
  };
  const run = debounce(async () => {
    const q = input.value.trim();
    if (q.length < 2) { close(); return; }
    if (q === lastQ) return; lastQ = q;
    if (ctrl) ctrl.abort(); ctrl = new AbortController();
    try {
      const url = `${T().routes.predictiveSearch}.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,body`;
      const res = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      render(q, await res.json());
    } catch (e) { /* aborted or offline */ }
  }, 220);
  input.addEventListener('input', run);
  input.addEventListener('focus', () => { if (input.value.trim().length >= 2 && box.innerHTML) box.hidden = false; });
  document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  input.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); if (e.key === 'ArrowDown') { const first = box.querySelector('a'); if (first) { e.preventDefault(); first.focus(); } } });
});
}
initPredictive(document);
document.addEventListener('shopify:section:load', (e) => initPredictive(e.target));
